<template>
    <div class="page page--center">
        <Header logo-size="xl" />
        <main class="page__main">
            <div class="content">
                <div class="content__body">
                    <Activation2Form />
                </div>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Activation2Form from '@/components/Activation2Form.vue'

export default {
    name: 'Activation2',
    components: {
        Header,
        Footer,
        Activation2Form,
    },
}
</script>
